import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "../../routes";
const Container = () => {
  return (
    <>
      <BrowserRouter>
        <div className="wrapper">
          <Routes />
        </div>
      </BrowserRouter>
    </>
  );
};

export default Container;
